import OrganizationChart from "@dabeng/react-orgchart";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { green } from "@material-ui/core/colors";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddBox from "@material-ui/icons/AddBox";
import AddIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import DocIcon from "@material-ui/icons/FileCopyOutlined";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Refresh from "@material-ui/icons/Refresh";
import Remove from "@material-ui/icons/Remove";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import SaveIcon from "@material-ui/icons/Save";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Autocomplete, {
	createFilterOptions
} from "@material-ui/lab/Autocomplete";
import axios from "axios";
import clsx from "clsx";
import MaterialTable from "material-table";
import React, { forwardRef, useEffect, useState } from "react";
import { store as storeNotification } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import validator from "validator";
import { updateUser } from "../actions/authActions";
import { convert } from "../actions/convertArrayToTree";
import { saveDocType } from "../actions/loadRoutes";
import {
	companySaveInitialize,
	companyUpdate
} from "../actions/saveCompanyInfo";
import { officeUpdate } from "../actions/saveOfficeInfo";
import { COMPANY_LOAD_INFO, OFFICE_LOAD_INFO, OFFICE_LOAD_INFO_INIT } from "../actions/types";
import { IP } from "../config/IP";
import store from "../store/createStore";
import EditStatusForm from "./EditStatusForm";
import MyNode from "./OrganisationNode";
import UserProfile from "./UserProfile";

const tableIcons = {
	Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
	Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
	Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
	DetailPanel: forwardRef((props, ref) => (
		<ChevronRight {...props} ref={ref} />
	)),
	Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
	Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
	Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
	FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
	LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
	NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
	PreviousPage: forwardRef((props, ref) => (
		<ChevronLeft {...props} ref={ref} />
	)),
	ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
	Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
	SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
	ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
	ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
	Refresh: forwardRef((props, ref) => <Refresh {...props} ref={ref} />),
};

const useStyles = makeStyles((theme) => ({
	rootProgress: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
	},
	root: {
		minWidth: 275,
		flexGrow: 1,
		//display: "flex",
		//flexWrap: "wrap",
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
			//width: "25ch",
			paddingLeft: 1,
		},
		root: {
			width: "100%",
			maxWidth: 360,
			backgroundColor: theme.palette.background.paper,
		},
		rootButton: {
			display: "flex",
			alignItems: "center",
		},

		dividerFullWidth: {
			margin: `5px 0 0 ${theme.spacing(2)}px`,
		},
		dividerInset: {
			margin: `5px 0 0 ${theme.spacing(9)}px`,
		},
		root: {
			width: "100%",
			maxWidth: 360,
			backgroundColor: theme.palette.background.paper,
		},
		dividerFullWidth: {
			margin: `5px 0 0 ${theme.spacing(2)}px`,
		},
		dividerInset: {
			margin: `5px 0 0 ${theme.spacing(9)}px`,
		},
	},

	bullet: {
		display: "inline-block",
		margin: "0 2px",
		transform: "scale(0.8)",
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
	buttonSuccess: {
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
	fabProgress: {
		color: green[500],
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

const OrganisationChart = (props) => {
	const state = useSelector((state) => state);
	const [photo, setPhoto] = useState({ hits: [] });
	const [username, setUsername] = useState();
	const [title, setTitle] = useState();
	const [shouldFetch, setShouldFetch] = useState(false);
	const [visibleOffice, setVisibleOffice] = useState("CompanyOffices");
	const [allCompanies, setAllCompanies] = useState(
		state.companyData.allCompany
	);
	const [selectedCompanyId, setSelectedCompanyId] = useState(
		allCompanies.length > 0 ? allCompanies[0]._id : ""
	);

	const [offices, setOffice] = useState([]);
	const [showNewOfficeForm, setShowNewOfficeForm] = useState({
		form: "None",
		data: {},
	});
	const [officeFormValue, setOfficeFormValue] = useState("");
	const [officeNameV, setOfficeNameV] = useState({});
	const [office_id, setOffice_id] = useState();
	const [rep_OfficeNameV, setRep_OfficeNameV] = useState({});
	const [orgChatData, setOrgChatData] = useState([]);
	const [toggleOrgView, setToggleOrgView] = useState(true);
	const [saveNewOfficeCond, setSaveNewOfficeCond] = useState(false);

	let { data, loading } = useFetch(
		{ username: username },
		shouldFetch,
		setShouldFetch,
		setPhoto
	);
	const styled = {
		nodeDetails: {
			width: "35%",
			paddingTop: "20%",
			//verticalAlign: "top",
		},
		chart: {
			width: "90%",
			height: "80%",
			verticalAlign: "top",
		},
		table: { width: "1010" },
	};
	const classes = useStyles();

	const selectNode = (nodeData) => {
		//console.log("selectNode clicked");

		setUsername(nodeData.name);
		setTitle(nodeData.title);
	};
	const setVisibleOfficeFx = (value) => {
		//console.log("setVisibleOfficeFx value=", value);
		if (value === "CompanyNew") {
			store.dispatch(companySaveInitialize());
		}
		setVisibleOffice(value);
	};
	const onChangeOfficeName = (event) => {
		console.log("onChangeOffice event.target.name=", event.target.name, " event.target.value=", event.target.value)


		setOfficeNameV(event.target.value)
	};
	const onChangeRepOfficeName = (office_id) => {



		setRep_OfficeNameV(office_id)
	};
	const toggleOrgViewFx = () => {
		setToggleOrgView(!toggleOrgView);
	};
	const handleSaveNewOffice = () => {
		//setSaveNewOfficeCond(false);
		setSaveNewOfficeCond(true);




	};
	//console.log("OrganizationChart props.data=", props.data);


	const OfficeForm = (props) => {
		console.log("OrganizationChart props.showNewOfficeForm=", props.showNewOfficeForm)
		useEffect(() => {

			try {
				if (props.showNewOfficeForm.form === "editOffice") {
					/*console.log("props.showNewOfficeForm.data.parent.split(#)[0]=",state.officeData.allOffice
								.filter((x) => x.companyId === selectedCompanyId && parseInt(x.office_id)===(props.showNewOfficeForm.data.parent
									? parseInt(props.showNewOfficeForm.data.parent.split("#")[0])
									: "")))
									*/
					setOffice_id(props.showNewOfficeForm.data.key.split("#")[0]);
					setOfficeNameV(props.showNewOfficeForm.data.title)
					setRep_OfficeNameV(props.showNewOfficeForm.data.parent.split("#")[0])
				}
				else {
					setOffice_id();
					setOfficeNameV()
					setRep_OfficeNameV()
				}
			}
			catch (e) {
				setOffice_id()
				setRep_OfficeNameV()
			}


		}, [props.showNewOfficeForm])
		return (
			<>
				{props.showNewOfficeForm.form === "createOffice" ? (
					<Box>
						New Office Form
						<TextField
							fullWidth
							id="officeName"
							name="officeName"
							label="office Name"
							variant="outlined"
							onChange={onChangeOfficeName}
						/>
						<Autocomplete
							onChange={(event, newValue) => {
								console.log(
									"add new office change onChange=",
									newValue
								);

								if (newValue.office_id)
									onChangeRepOfficeName(newValue.office_id);
							}}
							inputValue={
								state.auth.user.allOffices.filter(
									(x) =>
										x.office_id === rep_OfficeNameV &&
										x.companyId === selectedCompanyId
								).office_name
							}
							onInputChange={(event, newInputValue) => {
								console.log(
									"add Office newInputValue=",
									newInputValue
								);
							}}
							id="rep_office"
							options={state.officeData.allOffice
								.filter((x) => x.companyId === selectedCompanyId).sort((a, b) => a.office_name > b.office_name)}
							getOptionLabel={(option) => option.office_name}
							style={{ width: 300 }}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Rep Office"
									variant="outlined"
								/>
							)}
						/>


						{state.userStatus.status.roles.filter((x) => x.role === "ADMIN").length >
							0 && (
								<Button onClick={handleSaveNewOffice}> Save</Button>
							)}
					</Box>
				) : props.showNewOfficeForm.form === "editOffice" ? (
					<Box>
						Edit Office Form
						<TextField
							fullWidth
							id="officeName"
							name="officeName"
							label="office Name"
							variant="outlined"
							defaultValue={props.showNewOfficeForm.data.title}
							onChange={onChangeOfficeName}
						/>


						<Autocomplete
							onChange={(event, newValue) => {
								console.log(
									"add new office change onChange=",
									newValue
								);

								if (newValue.office_id)
									onChangeRepOfficeName(newValue.office_id);
							}}
							inputValue={
								state.auth.user.allOffices.filter(
									(x) =>
										x.office_id === rep_OfficeNameV &&
										x.companyId === selectedCompanyId
								).office_name
							}
							onInputChange={(event, newInputValue) => {
								console.log(
									"add Office newInputValue=",
									newInputValue
								);
							}}

							id="rep_office"
							defaultValue={state.officeData.allOffice
								.find((x) => x.companyId === selectedCompanyId && parseInt(x.office_id) === (props.showNewOfficeForm.data.parent
									? parseInt(props.showNewOfficeForm.data.parent.split("#")[0])
									: ""))}
							options={state.officeData.allOffice
								.filter((x) => x.companyId === selectedCompanyId).sort((a, b) => a.office_name > b.office_name)}
							getOptionLabel={(option) => option.office_name}
							style={{ width: 300 }}

							renderInput={(params) => (
								<TextField
									{...params}
									label="Rep Office"
									variant="outlined"
								/>
							)}
						/>
						{state.userStatus.status.roles.filter((x) => x.role === "ADMIN").length >
							0 && (
								<Button onClick={handleSaveNewOffice}> Save</Button>
							)}
					</Box>
				) : (
					""
				)}
			</>
		);
	};


	useEffect(() => {
		if (saveNewOfficeCond) {

			if (officeNameV && rep_OfficeNameV && (showNewOfficeForm.form === "editOffice" ? office_id : true)) {
				let inputs = {
					url: IP.nodeServer + "api/officeRegister",
					data: showNewOfficeForm.form === "editOffice" ? {
						office_name: officeNameV,
						office_id: parseInt(office_id),
						rep_office: rep_OfficeNameV + "",
						companyId: selectedCompanyId,
						action: showNewOfficeForm.form === "createOffice" ? "new_Office_save" : "update_Office_save",
					} : {
						office_name: officeNameV,
						rep_office: rep_OfficeNameV + "",
						companyId: selectedCompanyId,
						action: showNewOfficeForm.form === "createOffice" ? "new_Office_save" : "update_Office_save",
					}
				};

				console.log("OrganisationChart handleSaveNewOffice inputs=", inputs);
				store.dispatch(officeUpdate(inputs));
				store.dispatch({
					type: OFFICE_LOAD_INFO_INIT

				});

			}
			else {
				storeNotification.addNotification({
					title: "adding new Office!",
					message:
						"failed to add, fields 'office_name,rep_office,' must not be empty !",
					type: "danger",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				setSaveNewOfficeCond(false)



			}

		}

	}, [saveNewOfficeCond, setSaveNewOfficeCond])
	useEffect(() => {
		setOfficeFormValue(<OfficeForm showNewOfficeForm={showNewOfficeForm} />);
		console.log("useEffect showNewOfficeForm=", showNewOfficeForm);
	}, [showNewOfficeForm, setShowNewOfficeForm]);
	useEffect(() => {
		let Officetmp = [{ title: "New Office", name: "" }];

		// get office and user info
		var arry = Array.isArray(state.officeData?.allOffice) ? state.officeData?.allOffice.filter(
			(x) => x.companyId === selectedCompanyId
		) : [];
		var allUser = [];
		try {
			console.log(
				"OrganisationChart state.auth.user.allUser=",
				state.auth.user.allUser
			);
			allUser = state.auth.user.allUser.filter(
				(x) =>
					x.companies.map((x) => x.companyId).includes(selectedCompanyId)
				// &&.status === 1
			);
			console.log("OrganisationChart allUser=", allUser);
		} catch (e) {
			console.log("state.auth.user.allUser.filter e=", e);
		}
		console.log("OrganisationChart arry=", arry);
		let arrayUser = [];

		let parent = "";

		arry.map((x) => {
			let users = {};
			try {
				users = allUser.filter(
					(y) =>
						y.companies.map((x) => x.companyId).includes(selectedCompanyId) &&
						y.office_id === x.office_id
				);
			} catch (e) { }
			if (x.rep_office) {
				if (
					allUser.find(
						(y) =>
							y.companies.map((x) => x.companyId).includes(selectedCompanyId) &&
							y.office_id === x.rep_office
					)
				)
					parent =
						x.rep_office +
						"#" +
						allUser.find(
							(y) =>
								y.companies
									.map((x) => x.companyId)
									.includes(selectedCompanyId) && y.office_id === x.rep_office
						).username;
				else {
					parent = x.rep_office + "#vacant";
				}
			}
			if (users.length > 0) {
				users.map((z) => {
					let id = x.office_id + "#" + z.username;

					arrayUser.push({
						key: id,
						id: id,
						title: x.office_name,
						name: z.username,
						parent: parent,
					});
				});
			} else {
				let id = x.office_id + "#vacant";
				arrayUser.push({
					key: id,
					id: id,
					title: x.office_name,
					name: "vacant",
					parent: parent,
				});
			}
		});

		// end
		//
		console.log("OrganisationChart arrayUser=", arrayUser);
		let r = convert(arrayUser);
		console.log("OrganisationChart state=", state);
		if (arrayUser.length > 0) {
			Officetmp = Officetmp.concat(arrayUser);
		}
		console.log("OrganisationChart real r=", r);
		setOffice(Officetmp);
		setOrgChatData(r);
		setShowNewOfficeForm({
			form: "None",
			data: {},
		});
		setRep_OfficeNameV()
		setOfficeNameV()

	}, [selectedCompanyId, setSelectedCompanyId]);

	useEffect(() => {
		console.log("mount OrganizationChart Photo=", photo);
		return () => {
			console.log("unmount OrganizationChart Photo=", photo);
		};
	}, [username, setUsername]);

	useEffect(() => {
		console.log("mount OrganizationChart shouldFetch=", photo);

		return () => {
			console.log("unmount OrganizationChart shouldFetch=", photo);
		};
	}, [shouldFetch, setShouldFetch]);
	useEffect(() => {
		console.log("mount OrganizationChart loading=", loading);
		return () => {
			console.log("unmount OrganizationChart loading=", loading);
		};
	}, [loading]);
	console.log("props.structruredData=", props.structruredData);
	useEffect(() => {
		setAllCompanies(state.companyData.allCompany);
	}, []);

	React.useEffect(() => {
		console.log("React.useEffect officeNameV=", officeNameV)
	}, [officeNameV, setOfficeNameV])

	React.useEffect(() => {
		if (state.officeSave.isSaved) {
			console.log(
				"store.getState().officeSave.office.data=",
				state.officeSave.office.data
			);

			let AllOfficesV = state.officeData.allOffice;
			if (showNewOfficeForm.form === "createOffice") {
				AllOfficesV.push(state.officeSave.office.data);
			}
			if (showNewOfficeForm.form === "editOffice") {
				let index = AllOfficesV.findIndex(x => x.office_id === state.officeSave.office.data.office_id)
				console.log("changed index=", index)
				AllOfficesV[index] = state.officeSave.office.data;
				//AllOfficesV.map(x=>x.office_id===state.officeSave.office.data.office_id?state.officeSave.office.data:x)

			}

			store.dispatch({
				type: OFFICE_LOAD_INFO,
				payload: AllOfficesV,
			});
			setSaveNewOfficeCond(false)
			setShowNewOfficeForm({
				form: "None",
				data: {}
			})
			setOfficeFormValue("")

		}
	}, [state.officeSave.isSaved])
	useEffect(() => {
		console.log("state.officeSave.isFailed=", state.officeSave.isFailed)
		setSaveNewOfficeCond(false)

	}, [state.officeSave.isFailed])

	React.useEffect(() => {
		if (state.officeData.isLoaded) {// populate
			let Officetmp = [];
			if (
				state.userStatus.status.roles.filter((x) => x.role === "ADMIN").length >
				0
			) {
				Officetmp = [{ title: "New Office", name: "" }];
			}

			// get office and user info
			var arry = Array.isArray(state.officeData?.allOffice) ? state.officeData?.allOffice.filter(
				(x) => x.companyId === selectedCompanyId
			) : [];
			var allUser = state.auth.user.allUser.filter(
				(x) =>
					x.companies.map((x) => x.companyId).includes(selectedCompanyId)
					&& x.status === 1
			);
			console.log("OrganisationChart arry=", arry);
			let arrayUser = [];

			let parent = "";

			arry.map((x) => {
				let users = {};
				try {
					users = allUser.filter(
						(y) =>
							y.companies.map((x) => x.companyId).includes(selectedCompanyId) &&
							y.office_id === x.office_id
					);
				} catch (e) { }
				if (x.rep_office) {
					if (
						allUser.find(
							(y) =>
								y.companies
									.map((x) => x.companyId)
									.includes(selectedCompanyId) && y.office_id === x.rep_office
						)
					)
						parent =
							x.rep_office +
							"#" +
							allUser.find(
								(y) =>
									y.companies
										.map((x) => x.companyId)
										.includes(selectedCompanyId) && y.office_id === x.rep_office
							).username;
					else {
						parent = x.rep_office + "#vacant";
					}
				}
				if (users.length > 0) {
					users.map((z) => {
						let id = x.office_id + "#" + z.username;
						arrayUser.push({
							key: id,
							id: id,
							title: x.office_name,
							name: z.username,
							parent: parent,
						});
					});
				} else {
					let id = x.office_id + "#vacant";
					arrayUser.push({
						key: id,
						id: id,
						title: x.office_name,
						name: "vacant",
						parent: parent,
					});
				}
			});

			// end
			//
			console.log("OrganisationChart arrayUser=", arrayUser);
			let r = convert(arrayUser);
			console.log("OrganisationChart state=", state);
			if (arrayUser.length > 0) {
				Officetmp = Officetmp.concat(arrayUser);
			}
			console.log("OrganisationChart real r=", r);
			setOffice(Officetmp);
			setOrgChatData(r);
			// end of populate


		}
	}, [state.officeData.isLoaded])

	React.useEffect(() => {


	}, [])

	console.log("showNewOfficeForm=", showNewOfficeForm);
	console.log("state.userStatus.status.roles=", state.userStatus.status.roles);

	return (
		<div className={classes.root}>
			{visibleOffice === "CompanyOffices" ? (
				<>
					<p>available Offices</p>
					{(state.userStatus.status.roles.filter((x) => x.role === "ADMIN")
						.length > 0 ||
						(state.auth.user.office ? state.auth.user.office[0].office_id === 670 : false)) && (
							<>
								<Button
									onClick={() => {
										setVisibleOfficeFx("CompanyNew");
									}}
								>
									New Organisation
								</Button>

								{selectedCompanyId ? (
									<>
										<Button
											onClick={() => {
												setVisibleOfficeFx("CompanyDetails");
											}}
										>
											Company Details
										</Button>
										<Button
											onClick={() => {
												setVisibleOfficeFx("DocSetup");
											}}
										>
											Document setup
										</Button>
									</>
								) : (
									""
								)}
							</>
						)}

					<Autocomplete
						onChange={(event, value) => {
							console.log(" Autocomplete value=", value);
							try {
								setSelectedCompanyId(value._id);
								showNewOfficeForm({ form: "None", data: {} });
							} catch (e) { }
						}}
						id="companies"
						options={allCompanies}
						defaultValue={allCompanies.length > 0 ? allCompanies[0] : {}}
						getOptionLabel={(option) => option.companyName}
						style={{ width: 300 }}
						renderInput={(params) => (
							<TextField {...params} label="Company" variant="outlined" />
						)}
					/>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<Paper className={classes.paper}>
								<Autocomplete
									onChange={(event, value) => {
										console.log("Autocomplete Office Select value=", value);
										try {
											if (value.title === "New Office") {
												setShowNewOfficeForm({
													...showNewOfficeForm,
													form: "createOffice",
													data: {},
												});
												//return;
											} else if (value.title !== "") {

												setShowNewOfficeForm({
													...showNewOfficeForm,
													data: value,
													form: "editOffice",
												});

												try {

													document
														.getElementById(value.key)
														.scrollIntoView(false);
												} catch (e) { }
											}
										} catch (e) { }
									}}
									id="offices"
									options={offices}
									getOptionLabel={(option) => {
										return option.title + " " + option.name;
									}}
									style={{ width: 300 }}
									renderInput={(params) => (
										<TextField {...params} label="Office" variant="outlined" />
									)}
								/>

								{false && (
									<UserProfile
										userName={username}
										title={title}
										photo={photo}
									/>
								)}
							</Paper>
							<Paper className={classes.paper}>{officeFormValue}</Paper>
						</Grid>
						<Grid item xs={8}>
							<Button onClick={toggleOrgViewFx}>
								Switch to {toggleOrgView ? "Table" : "Chart"} View
							</Button>
							{toggleOrgView ? (
								<Paper
									className={classes.paper}
									style={{ maxWidth: 800, overflow: "auto" }}
								>
									<TransformWrapper
										defaultScale={1}
										defaultPositionX={200}
										defaultPositionY={100}
									>
										{({ zoomIn, zoomOut, resetTransform, ...rest }) => (
											<>
												<div className="tools">
													<button onClick={zoomIn}>+</button>
													<button onClick={zoomOut}>-</button>
													<button onClick={resetTransform}>x</button>
												</div>
												<TransformComponent>
													{orgChatData ? (
														<OrganizationChart
															datasource={
																orgChatData.length > 0 ? orgChatData[0] : {}
															}
															chartClass="myChart chartCustom"
															NodeTemplate={MyNode}
															onClickNode={(data) => {
																selectNode(data);
																setShouldFetch(true);
															}}
															pan={true}
														/>
													) : (
														""
													)}
												</TransformComponent>
											</>
										)}
									</TransformWrapper>
								</Paper>
							) : (
								<UserTreeTable selectedCompanyId={selectedCompanyId} />
							)}
						</Grid>
					</Grid>
				</>
			) : (
				<>
					{visibleOffice === "CompanyNew" ? (
						<>
							<p>Create new Organisation</p>
							<Button
								onClick={() => {
									setVisibleOfficeFx("CompanyOffices");
								}}
							>
								{" "}
								<ArrowBackIcon />
							</Button>
							<CreateCompanyForm />
						</>
					) : visibleOffice === "CompanyDetails" ? (
						<>
							<p>View Company Details</p>
							<Button
								onClick={() => {
									setVisibleOfficeFx("CompanyOffices");
								}}
							>
								<ArrowBackIcon />
							</Button>
							<ViewCompany selectedCompanyId={selectedCompanyId} />
						</>
					) : (
						<>
							<p>Document Setting</p>
							<Button
								onClick={() => {
									setVisibleOfficeFx("CompanyOffices");
								}}
							>
								<ArrowBackIcon />
							</Button>
							<DocumentSetting selectedCompanyId={selectedCompanyId} />
						</>
					)}
				</>
			)}
		</div>
	);
};

function useFetch(query, shouldFetch, setShouldFetch, setPhoto) {
	console.log(" OrganisationChart In usefetch unction query=", query);
	const [state, setState] = useState({ data: null, loading: true });

	const token = localStorage.getItem("token");

	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	useEffect(() => {
		async function fetchData(query, setShouldFetch, setPhoto) {
			console.log("query in fetchData=", query);
			let output = await axios.get(
				IP.nodeServer + "api/profileimage/" + query.username,
				config
			);
			//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
			console.log("return output=", output);
			if (output) {
				setState({ data: output, loading: false });
				setShouldFetch(false);
				try {
					var buffer = Buffer.from(output.data.image.picture.data).toString(
						"base64"
					);

					setPhoto("data:image/png;base64," + buffer.toString(buffer));
				} catch (e) {
					setPhoto("person.png");
				}
			}
		}
		if (shouldFetch) {
			fetchData(query, setShouldFetch, setPhoto);
		}
	}, [query, shouldFetch, setShouldFetch]);
	return state;
}

const CreateCompanyForm = (props) => {
	const classes = useStyles();
	const state = useSelector((state) => state);
	const [open, setOpen] = React.useState(false);
	let companycontactsEmail = [{ email: null }];
	let companycontactsPhoneNumber = [{ contryCode: null, phone: null }];

	const [emails, setEmails] = useState([]);
	const [phones, setPhones] = useState([]);

	React.useEffect(() => { }, []);

	const filter = createFilterOptions();

	const [site, setSite] = React.useState([]);
	const [sitev, setSitev] = React.useState({ companyMainCountry: "RW" });
	const [value, setValue] = React.useState(null);
	const [country, setCountry] = React.useState("RW");
	const tableRef = React.createRef();
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const [open2, toggleOpen] = React.useState(false);

	const handleClose2 = () => {
		setDialogValue({
			title: "",
			year: "",
		});

		toggleOpen(false);
	};

	const [dialogValue, setDialogValue] = React.useState({
		title: "",
		year: "",
	});
	const [columns, setColumns] = useState([
		{
			title: "name",
			field: "name",
		},
		{
			title: "country",
			field: "country",
			lookup: { RW: "RWANDA" },
		},
		{
			title: "province",
			field: "province",
		},
		{ title: "district", field: "district" },
		{ title: "address", field: "address" },

		{
			title: "contactsEmail",
			field: "email",
			render: (rowData) => {
				rowData.join(";");
			},
			editComponent: (props) => {
				return (
					<Autocomplete
						onChange={(event, newValue, reason) => {
							console.log("Autocomplete newValue=", newValue, reason);
							setEmails(newValue);
							onChangeSite(event);
						}}
						filterOptions={(options, params) => {
							const filtered = filter(options, params);

							// Suggest the creation of a new value
							if (params.inputValue !== "") {
								if (validator.isEmail(params.inputValue)) {
									console.log(
										"ValidateEmail params.inputValue=",
										params.inputValue
									);
									filtered.push({
										inputValue: params.inputValue,
										title: `Add "${params.inputValue}"`,
									});
								}
							}
							//console.log("value=", value);
							//filtered.push(value);

							return filtered;
						}}
						name="email"
						id="companycontactsEmailSelect"
						options={[]}
						getOptionLabel={(option) => {
							// Value selected with enter, right from the input
							if (typeof option === "string") {
								return option;
							}
							// Add "xxx" option created dynamically
							if (option.inputValue) {
								return option.inputValue;
							}
							// Regular option
							return option.title;
						}}
						multiple
						renderOption={(option) => {
							try {
								return option.title;
							} catch (e) { }
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Contact Email"
								placeholder="Email"
								type="email"
								onChange={(value) => {
									//ValidateEmail()
									console.log("TextField value=", value.target);
								}}
							/>
						)}
					/>
				);
			},
		},
		{
			title: "contactsPhoneNumber",
			field: "phones",
			editComponent: (props) => {
				return (
					<Autocomplete
						onChange={(event, newValue, reason) => {
							console.log("Autocomplete newValue=", newValue, reason);
							setPhones(newValue);
							onChangeSite(event);
						}}
						filterOptions={(options, params) => {
							const filtered = filter(options, params);

							// Suggest the creation of a new value
							if (params.inputValue !== "") {
								if (validator.isMobilePhone(params.inputValue)) {
									console.log(
										"ValidatePhone params.inputValue=",
										params.inputValue
									);
									filtered.push({
										inputValue: params.inputValue,
										title: `Add "${params.inputValue}"`,
									});
								}
							}
							//console.log("value=", value);
							//filtered.push(value);

							return filtered;
						}}
						id="companycontactsPhoneSelect"
						name="phones"
						options={[]}
						getOptionLabel={(option) => {
							// Value selected with enter, right from the input
							if (typeof option === "string") {
								return option;
							}
							// Add "xxx" option created dynamically
							if (option.inputValue) {
								return option.inputValue;
							}
							// Regular option
							return option.title;
						}}
						multiple
						renderOption={(option) => {
							try {
								return option.title;
							} catch (e) { }
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Contact Phone"
								placeholder="Phone"
								type="phone"
								onChange={(value) => {
									//ValidateEmail()
									console.log("TextField value=", value.target);
								}}
							/>
						)}
					/>
				);
			},
		},
	]);

	const [data, setData] = useState([]);

	const handleChangeCountry = (value) => {
		setCountry(value);
	};

	let filteredv = [];
	const handleFilteredPhoneNumber = () => {
		filteredv.push(dialogValue);
	};
	const onChangeSite = (event) => {
		setSitev({ ...sitev, [event.target.name]: event.target.value });
	};

	const handleAddSite = () => {
		console.log(sitev);
		let sitetmp = site;
		sitetmp.push(sitev);
		setSite(sitetmp);

		//tableRef.current.onQueryChange();

		handleClose();
	};

	const handleSaveMainInfo = () => {
		console.log("handleSaveMainInfo lciked");
		let inputs = {
			url: IP.nodeServer + "api/companyRegister",
			data: {
				sites: sitev,
				phones: phones,
				emails: emails,
				action: "new_company_save",
			},
		};

		console.log("OrganisationChart inputs=", inputs);

		store.dispatch(companyUpdate(inputs));
	};
	React.useEffect(() => {
		console.log("site=", site);
		try {
			//if (tableRef.current) tableRef.current.onQueryChange();
		} catch (e) { }
	}, [site, setSite]);
	useEffect(() => {
		if (state.companySave.isSaved) {
			let Companies = state.companyData.allCompany;
			if (
				state.companyData.allCompany.filter(
					(x) => x._id === state.companySave.company.data._id
				).length === 0
			) {
				Companies.push(state.companySave.company.data);
				store.dispatch({ type: COMPANY_LOAD_INFO, payload: Companies });
			}
		}
	}, [state.companySave.company.data]);

	return (
		<>
			{!state.companySave.isSaved ? (
				<>
					<li>
						<Typography
							className={classes.dividerFullWidth}
							color="textSecondary"
							display="block"
							variant="caption"
						>
							Company Main Info
						</Typography>

						<Box width="75%" justifyContent="flex-start">
							<form className={classes.root} noValidate autoComplete="off">
								<div>
									<TextField
										fullWidth
										id="companyName"
										name="companyName"
										label="Company Name"
										variant="outlined"
										defaultValue={
											state.companySave.isSaved
												? state.companySave.company.data.companyName
												: ""
										}
										onChange={onChangeSite}
									/>
								</div>
								<div>
									<TextField
										id="companyShortName"
										name="companyShortName"
										label="companyShortName"
										variant="outlined"
										disabled={state.companySave.isSaved}
										defaultValue={
											state.companySave.isSaved
												? state.companySave.company.data.companyShortName
												: ""
										}
										onChange={onChangeSite}
									/>

									<TextField
										fullWidth
										id="companyShortDescription"
										name="companyShortDescription"
										label="companyShortDescription"
										variant="outlined"
										disabled={state.companySave.isSaved}
										defaultValue={
											state.companySave.isSaved
												? state.companySave.company.data.companyShortName
												: ""
										}
										onChange={onChangeSite}
									/>
								</div>

								<TextField
									id="companyMainCountry"
									name="companyMainCountry"
									name="country"
									select
									label="Country"
									helperText="Please select your country"
									defaultValue="RW"
									onChange={onChangeSite}
								>
									<MenuItem value={"RW"}>Rwanda</MenuItem>
								</TextField>
							</form>
						</Box>
					</li>
					<li>
						<Typography
							className={classes.dividerFullWidth}
							color="textSecondary"
							display="block"
							variant="caption"
						>
							Site
						</Typography>
						<Box width="90%" justifyContent="flex-start">
							<TextField
								fullWidth
								required
								id="site-name"
								name="name"
								label="Site Name"
								placeholder="Site Name"
								variant="outlined"
								onChange={onChangeSite}
							/>
							<TextField
								fullWidth
								required
								id="address"
								name="address"
								label="address"
								placeholder="address"
								variant="outlined"
								onChange={onChangeSite}
							/>
							<TextField
								fullWidth
								required
								id="district"
								name="district"
								label="district"
								placeholder="district"
								variant="outlined"
								onChange={onChangeSite}
							/>
							<TextField
								fullWidth
								required
								id="province"
								name="province"
								label="province"
								placeholder="province"
								variant="outlined"
								onChange={onChangeSite}
							/>

							<TextField
								id="standard-select-country"
								name="country"
								select
								label="Country"
								helperText="Please select your country"
								onChange={onChangeSite}
							>
								<MenuItem value={"RW"}>Rwanda</MenuItem>
							</TextField>

							<Autocomplete
								onChange={(event, newValue, reason) => {
									console.log("Autocomplete newValue=", newValue, reason);
									setEmails(newValue);
								}}
								filterOptions={(options, params) => {
									const filtered = filter(options, params);

									// Suggest the creation of a new value
									if (params.inputValue !== "") {
										if (validator.isEmail(params.inputValue)) {
											console.log(
												"ValidateEmail params.inputValue=",
												params.inputValue
											);
											filtered.push({
												inputValue: params.inputValue,
												title: `Add "${params.inputValue}"`,
											});
										}
									}
									//console.log("value=", value);
									//filtered.push(value);

									return filtered;
								}}
								name="email"
								id="companycontactsEmailSelect"
								options={[]}
								getOptionLabel={(option) => {
									// Value selected with enter, right from the input
									if (typeof option === "string") {
										return option;
									}
									// Add "xxx" option created dynamically
									if (option.inputValue) {
										return option.inputValue;
									}
									// Regular option
									return option.title;
								}}
								multiple
								renderOption={(option) => {
									try {
										return option.title;
									} catch (e) { }
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label="Contact Email"
										placeholder="Email"
										type="email"
										onChange={(value) => {
											//ValidateEmail()
											console.log("Email TextField value=", value.target);
										}}
									/>
								)}
							/>
							<Autocomplete
								onChange={(event, newValue, reason) => {
									console.log("Autocomplete newValue=", newValue, reason);
									setPhones(newValue);
								}}
								filterOptions={(options, params) => {
									const filtered = filter(options, params);

									// Suggest the creation of a new value
									if (params.inputValue !== "") {
										if (validator.isMobilePhone(params.inputValue)) {
											console.log(
												"ValidatePhone params.inputValue=",
												params.inputValue
											);
											filtered.push({
												inputValue: params.inputValue,
												title: `Add "${params.inputValue}"`,
											});
										}
									}
									//console.log("value=", value);
									//filtered.push(value);

									return filtered;
								}}
								id="companycontactsPhoneSelect"
								name="phones"
								options={[]}
								getOptionLabel={(option) => {
									// Value selected with enter, right from the input
									if (typeof option === "string") {
										return option;
									}
									// Add "xxx" option created dynamically
									if (option.inputValue) {
										return option.inputValue;
									}
									// Regular option
									return option.title;
								}}
								multiple
								renderOption={(option) => {
									try {
										return option.title;
									} catch (e) { }
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="standard"
										label="Contact Phone"
										placeholder="Phone"
										type="phone"
										onChange={(value) => {
											//ValidateEmail()
											console.log(
												"Contact Phone TextField value=",
												value.target
											);
										}}
									/>
								)}
							/>
						</Box>
					</li>
					<div>
						<Button onClick={handleSaveMainInfo}> Save </Button>
					</div>
				</>
			) : (
				<Box width="90%" justifyContent="flex-start">
					the Company {state.companySave.company.data.companyName} was created
					Successfully{" "}
				</Box>
			)}
		</>
	);
};

const ViewCompany = (props) => {
	const classes = useStyles();
	const state = useSelector((state) => state);
	const [open, setOpen] = React.useState(false);
	let companycontactsEmail = [{ email: null }];
	let companycontactsPhoneNumber = [{ contryCode: null, phone: null }];

	const [emails, setEmails] = useState([]);
	const [phones, setPhones] = useState([]);

	React.useEffect(() => { }, []);

	const filter = createFilterOptions();

	let selectedCompany = state.companyData.allCompany.filter(
		(x) => x._id === props.selectedCompanyId
	);

	const [site, setSite] = React.useState([]);
	const [sitev, setSitev] = React.useState({ companyMainCountry: "RW" });
	const [value, setValue] = React.useState(null);
	const [country, setCountry] = React.useState("RW");
	const tableRef = React.createRef();
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const [open2, toggleOpen] = React.useState(false);

	const handleClose2 = () => {
		setDialogValue({
			title: "",
			year: "",
		});

		toggleOpen(false);
	};

	const [dialogValue, setDialogValue] = React.useState({
		title: "",
		year: "",
	});
	const [columns, setColumns] = useState([
		{
			title: "name",
			field: "name",
		},
		{ title: "country", field: "country", lookup: { RW: "RWANDA" } },
		{
			title: "province",
			field: "province",
		},
		{ title: "district", field: "district" },
		{ title: "address", field: "address" },

		{
			title: "contactsEmail",
			field: "email",
			render: (rowData) => {
				//rowData.join(";");
				//return rowData.join(";");
				//console.log("contactsEmail rowData=", rowData);
				try {
					return rowData.companycontactsEmail
						.map((x) => x["email"])
						.filter((v) => v)
						.join(";");
				} catch (e) {
					return "";
				}
			},
			editComponent: (props) => {
				return (
					<Autocomplete
						onChange={(event, newValue, reason) => {
							console.log("Autocomplete newValue=", newValue, reason);
							setEmails(newValue);
							onChangeSite(event);
						}}
						filterOptions={(options, params) => {
							const filtered = filter(options, params);

							// Suggest the creation of a new value
							if (params.inputValue !== "") {
								if (validator.isEmail(params.inputValue)) {
									console.log(
										"ValidateEmail params.inputValue=",
										params.inputValue
									);
									filtered.push({
										inputValue: params.inputValue,
										title: `Add "${params.inputValue}"`,
									});
								}
							}
							//console.log("value=", value);
							//filtered.push(value);

							return filtered;
						}}
						name="email"
						id="companycontactsEmailSelect"
						options={[]}
						getOptionLabel={(option) => {
							// Value selected with enter, right from the input
							if (typeof option === "string") {
								return option;
							}
							// Add "xxx" option created dynamically
							if (option.inputValue) {
								return option.inputValue;
							}
							// Regular option
							return option.title;
						}}
						multiple
						renderOption={(option) => {
							try {
								return option.title;
							} catch (e) { }
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Contact Email"
								placeholder="Email"
								type="email"
								onChange={(value) => {
									//ValidateEmail()
									console.log("Email TextField value=", value.target);
								}}
							/>
						)}
					/>
				);
			},
		},
		{
			title: "contactsPhoneNumber",
			field: "phones",
			render: (rowData) => {
				try {
					return rowData.companycontactsPhoneNumber
						.map((x) => x["phone"])
						.filter((v) => v)
						.join(";");
				} catch (e) {
					return "";
				}
			},
			editComponent: (props) => {
				return (
					<Autocomplete
						onChange={(event, newValue, reason) => {
							console.log("Autocomplete newValue=", newValue, reason);
							setPhones(newValue);
							onChangeSite(event);
						}}
						filterOptions={(options, params) => {
							const filtered = filter(options, params);

							// Suggest the creation of a new value
							if (params.inputValue !== "") {
								if (validator.isMobilePhone(params.inputValue)) {
									console.log(
										"ValidatePhone params.inputValue=",
										params.inputValue
									);
									filtered.push({
										inputValue: params.inputValue,
										title: `Add "${params.inputValue}"`,
									});
								}
							}
							//console.log("value=", value);
							//filtered.push(value);

							return filtered;
						}}
						id="companycontactsPhoneSelect"
						name="phones"
						options={[]}
						getOptionLabel={(option) => {
							// Value selected with enter, right from the input
							if (typeof option === "string") {
								return option;
							}
							// Add "xxx" option created dynamically
							if (option.inputValue) {
								return option.inputValue;
							}
							// Regular option
							return option.title;
						}}
						multiple
						renderOption={(option) => {
							try {
								return option.title;
							} catch (e) { }
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Contact Phone"
								placeholder="Phone"
								type="phone"
								onChange={(value) => {
									//ValidateEmail()
									console.log("Contact Phone TextField value=", value.target);
								}}
							/>
						)}
					/>
				);
			},
		},
	]);

	const [data, setData] = useState(
		state.companyData.allCompany.filter(
			(x) => x._id === props.selectedCompanyId
		)[0].site
	);

	const handleChangeCountry = (value) => {
		setCountry(value);
	};

	let filteredv = [];

	const onChangeSite = (event) => {
		console.log(
			"onChangeSite site=",
			event.target.name + "==" + event.target.value
		);
		setSitev({ ...sitev, [event.target.name]: event.target.value });
	};

	const handleAddSite = () => {
		console.log(sitev);
		let sitetmp = site;
		sitetmp.push(sitev);
		setSite(sitetmp);

		//tableRef.current.onQueryChange();

		handleClose();
	};

	const handleSaveMainInfo = () => {
		console.log("handleSaveMainInfo lciked");
		let inputs = {
			url: IP.nodeServer + "api/companyRegister",
			data: {
				companyId: props.selectedCompanyId,
				sites: sitev,
				phones: phones,
				emails: emails,
				action: "new_site_save",
			},
		};
		console.log("First inputs=", inputs);
		inputs = {
			url: IP.nodeServer + "api/companyRegister",

			data: [
				{ name: "companyName", value: sitev.companyName },
				{ name: "companyShortName", value: sitev.companyShortName },
				{
					name: "companyShortDescription",
					value: sitev.companyShortDescription,
				},
				{ name: "companyMainCountry", value: sitev.companyMainCountry },
				{ name: "action", value: "new_company_save" },
			],
		};
		console.log("OrganisationChart inputs=", inputs);

		//store.dispatch(companySave(inputs));
	};
	React.useEffect(() => {
		console.log("site=", site);
		try {
			//if (tableRef.current) tableRef.current.onQueryChange();
		} catch (e) { }
	}, [site, setSite]);
	useEffect(() => {
		if (state.companySave.isSaved) {
			let Companies = state.companyData.allCompany;
			if (
				state.companyData.allCompany.filter(
					(x) => x._id === state.companySave.company.data._id
				).length === 0
			) {
				Companies.push(state.companySave.company.data);
				store.dispatch({ type: COMPANY_LOAD_INFO, payload: Companies });
			}
		}
	}, [state.companySave.company.data]);

	console.log("ViewCompany selectedCompanyId=", props.selectedCompanyId);

	return (
		<>
			<Box width="75%" justifyContent="flex-start">
				<form className={classes.root} noValidate autoComplete="off">
					<div>
						<TextField
							fullWidth
							id="companyName"
							name="companyName"
							label="Company Name"
							variant="outlined"
							defaultValue={selectedCompany[0].companyName}
							onChange={onChangeSite}
						/>
					</div>
					<div>
						<TextField
							id="companyShortName"
							name="companyShortName"
							label="companyShortName"
							variant="outlined"
							disabled={state.companySave.isSaved}
							defaultValue={selectedCompany[0].companyShortName}
							onChange={onChangeSite}
						/>

						<TextField
							fullWidth
							id="companyShortDescription"
							name="companyShortDescription"
							label="companyShortDescription"
							variant="outlined"
							disabled={state.companySave.isSaved}
							defaultValue={selectedCompany[0].companyShortDescription}
							onChange={onChangeSite}
						/>
					</div>
					<TextField
						id="companyMainCountry"
						name="companyMainCountry"
						name="country"
						select
						label="Country"
						helperText="Please select your country"
						defaultValue="RW"
						onChange={onChangeSite}
					>
						<MenuItem value={"RW"}>Rwanda</MenuItem>
					</TextField>
					<div>
						<Button onClick={handleSaveMainInfo}> Save </Button>
					</div>
				</form>
			</Box>

			<Box width="90%" justifyContent="flex-start">
				<div>
					{" "}
					Site
					<MaterialTable
						icons={tableIcons}
						detailPanel={(rowData) => {
							return (
								<UserInSite
									data={{
										siteId: rowData._id,
										companyId: props.selectedCompanyId,
									}}
								/>
							);
						}}
						tableRef={tableRef}
						title="Company sites"
						columns={columns}
						data={data}
						editable={{
							onRowAdd: (newData) =>
								new Promise((resolve, reject) => {
									setTimeout(async () => {
										console.log("view MaterialTable phones=", phones);
										console.log("view MaterialTable emails=", emails);
										console.log("view MaterialTable newData=", newData);
										let inputs = {
											url: IP.nodeServer + "api/companyRegister",
											data: {
												companyId: props.selectedCompanyId,
												sites: newData,
												phones: phones,
												emails: emails,
												action: "new_site_save",
											},
										};
										console.log("OrganisationChart inputs=", inputs);

										await store.dispatch(companyUpdate(inputs));

										console.log(
											"state.companySave=",
											store.getState().companySave
										);
										try {
											setData([
												...data,
												store.getState().companySave.company.data.site[
												store.getState().companySave.company.data.site
													.length - 1
												],
											]);
										} catch (e) { }

										resolve();
									}, 1000);
								}),
							onRowUpdate: (newData, oldData) =>
								new Promise((resolve, reject) => {
									setTimeout(() => {
										const dataUpdate = [...data];
										const index = oldData.tableData.id;
										dataUpdate[index] = newData;
										setData([...dataUpdate]);

										resolve();
									}, 1000);
								}),
							onRowDelete: (oldData) =>
								new Promise((resolve, reject) => {
									setTimeout(() => {
										const dataDelete = [...data];
										const index = oldData.tableData.id;
										dataDelete.splice(index, 1);
										setData([...dataDelete]);

										resolve();
									}, 1000);
								}),
						}}
					/>
				</div>
			</Box>
		</>
	);
};
const UserInSite = (props) => {
	const { useState, createRef } = React;
	const state = useSelector((state) => state);
	const tableRef = createRef();
	const [params, setParams] = useState({
		username: "",
		office_id: "",
		roles: [],
	});
	let paramsv = params;

	const handleChangeUserSite = (event, value) => {
		if (event.target.name) {
			paramsv = { ...paramsv, [event.target.name]: event.target.value };
		} else {
			if (value.length) {
				paramsv = { ...paramsv, roles: value.map((x) => ({ role: x })) };
				console.log("handleChangeUserRole paramsv=", paramsv);
			}
		}

		console.log("handleChangeUserSite paramsv=", paramsv);

		setParams(paramsv);
	};
	const handleChangeUserRole = (value) => {
		console.log("handleChangeUserRole value=", value);
		try {
			let paramsv = params;
			if (value.length) {
				paramsv = { ...paramsv, roles: value.map((x) => ({ role: x })) };
				console.log("handleChangeUserRole paramsv=", paramsv);
				setParams(paramsv);
			}

			//
		} catch (e) { }
	};
	const RoleSelect = (props) => {
		let dataInfo = [
			{ title: "NORMAL", name: "NORMAL" },
			{ title: "ADMIN", name: "ADMIN" },
			{ title: "STOCK_MNG", name: "STOCK_MNG" },
			{ title: "DUTY_MNG", name: "DUTY_MNG" },
		];
		return (
			<Autocomplete
				id="roles"
				name="roles"
				onChange={(event, newValue, reason) => {
					console.log(
						"handleChangeUserRole Autocomplete newValue=",
						newValue,
						reason
					);
					handleChangeUserSite(event, newValue);
					props.onChange(newValue);
				}}
				multiple
				options={dataInfo.map((option) => option.title)}
				freeSolo
				renderTags={(value, getTagProps) => {
					return value.map((option, index) => (
						<Chip
							variant="outlined"
							label={option}
							{...getTagProps({ index })}
						/>
					));
				}}
				renderInput={(params) => {
					return (
						<TextField
							{...params}
							variant="filled"
							label="Role"
							placeholder="Select A Role"
						/>
					);
				}}
			/>
		);
	};

	const [columns, setColumns] = useState([
		{ title: "Name", field: "name", editable: "never" },
		{
			title: "Office",
			field: "office_id",
			render: (rowData) =>
				state.auth.user.allOffices.find(
					(x) =>
						x.office_id === rowData.office_id &&
						x.companyId === props.data.companyId
				)
					? state.auth.user.allOffices.find(
						(x) =>
							x.office_id === rowData.office_id &&
							x.companyId === props.data.companyId
					).office_name
					: "",
			editComponent: (property) => (
				<Autocomplete
					onChange={(event, newValue) => {
						console.log(" new office change onChange=", newValue);

						if (newValue.office_id)
							handleChangeUserSite({
								target: { name: "office_id", value: newValue.office_id },
							});
						{
							property.onChange(newValue.office_id);
						}
					}}
					inputValue={
						state.auth.user.allOffices.filter(
							(x) =>
								x.office_id === property.value &&
								x.companyId === props.data.companyId
						).office_name
					}
					onInputChange={(event, newInputValue) => {
						console.log("remove Office newInputValue=", newInputValue);
					}}
					id="combo-box-demo"
					options={state.auth.user.allOffices.filter(
						(x) => x.companyId === props.data.companyId
					)}
					getOptionLabel={(option) => option.office_name}
					style={{ width: 300 }}
					renderInput={(params) => (
						<TextField {...params} label="Office Name" variant="outlined" />
					)}
				/>
			),
		},
		{
			title: "username",
			field: "username",

			editable: "onAdd",
			editComponent: (property) => (
				<Autocomplete
					onChange={(event, newValue) => {
						console.log("remove new office change onChange=", newValue);
						if (newValue) {

							if (newValue.username) {
								handleChangeUserSite({
									target: { name: "username", value: newValue.username },
								});
								property.onChange(newValue.username);
							}
						}
					}}
					inputValue={
						state.auth.user.allUser.filter(
							(x) =>
								x.username === property.value &&
								x.companies
									.map((x) => x.companyId)
									.includes(props.data.companyId)
						).name
					}
					onInputChange={(event, newInputValue) => {
						console.log("username newInputValue=", newInputValue);
					}}
					id="username"
					options={state.auth.user.allUser.filter(
						(x) =>
							x.status === 1 &&
							x.companies.map((x) => x.companyId).includes(props.data.companyId)
					)}
					getOptionLabel={(option) => option.name}
					style={{ width: 300 }}
					renderInput={(params) => (
						<TextField {...params} label="username" variant="outlined" />
					)}
				/>
			),
		},

		{
			title: "Role",
			field: "roles",
			render: (rowData) => {
				try {
					return rowData.roles.length > 0
						? rowData.roles.map((x) => x.role).join(";")
						: "";
				} catch (e) { }
			},

			editComponent: (property) => {
				let dataInfo = [
					{ title: "NORMAL", name: "NORMAL" },
					{ title: "ADMIN", name: "ADMIN" },
					{ title: "STOCK_MNG", name: "STOCK_MNG" },
					{ title: "DUTY_MNG", name: "DUTY_MNG" },
				];
				return (
					<Autocomplete
						id="roles"
						name="roles"
						onChange={(event, newValue, reason) => {
							console.log(
								"handleChangeUserRole Autocomplete newValue=",
								newValue,
								reason
							);
							handleChangeUserSite(event, newValue);
							property.onChange(newValue);
						}}
						multiple
						options={dataInfo.map((option) => option.title)}
						freeSolo
						renderTags={(value, getTagProps) => {
							return value.map((option, index) => (
								<Chip
									variant="outlined"
									label={option}
									{...getTagProps({ index })}
								/>
							));
						}}
						renderInput={(params) => {
							return (
								<TextField
									{...params}
									variant="filled"
									label="Role"
									placeholder="Select A Role"
								/>
							);
						}}
					/>
				);
			},
		},
	]);

	const [data, setData] = useState([]);

	useEffect(() => {
		console.log("UserInSite params=", params);
	}, [params, setParams]);

	console.log("UserInSite props=", props);

	return (
		<MaterialTable
			icons={tableIcons}
			tableRef={tableRef}
			title="Users"
			columns={columns}
			editable={{
				onRowAdd: (newData) =>
					new Promise((resolve, reject) => {
						if (!newData.office_id || !newData.roles || !newData.username) {
							storeNotification.addNotification({
								title: "adding new Doctype!",
								message:
									"failed to add, fields 'office_id,roles,username' must not be empty !",
								type: "danger",
								insert: "top",
								container: "top-right",
								animationIn: ["animated", "fadeIn"],
								animationOut: ["animated", "fadeOut"],
								dismiss: {
									duration: 5000,
									onScreen: true,
								},
							});
							return reject();
						}
						console.log("newData=", newData);
						setTimeout(async () => {
							const token = localStorage.getItem("token");
							const config = {
								headers: {
									"x-auth-token": token,
									"content-type": "application/json",
								},
							};
							let inputs = {
								...params,
								siteId: props.data.siteId,
								companyId: props.data.companyId,
								action: "map_user_to_site",
							};
							console.log("UserInSite action map_user_to_site inputs=", inputs);

							axios
								.post(IP.nodeServer + "api/manageUsers", inputs, config)
								.then((response) => {
									console.log(
										"UserInSite map_user_to_site response.data.map((x) => ({username: x.username,name: x.name,office_id: x.office_id,id: x._id,}))=",
										response.data
									);
									let value = [...data, response.data];
									console.log("UserInSite Value=", value);
									setData(value);
									tableRef.current && tableRef.current.onQueryChange();
									resolve();
									console.log(
										"UserInSite map_user_to_site response.data=",
										response.data
									);
								})
								.catch((error) => {
									console.log("UserInSite map_user_to_site error=", error);
									reject();
								});
						}, 1000);
					}),
				onRowUpdate: (newData, oldData) =>
					new Promise((resolve, reject) => {
						if (!newData.office_id || !newData.roles || !newData.username) {
							storeNotification.addNotification({
								title: "adding new User!",
								message:
									"failed to add, fields 'office_id,roles,username' must not be empty !",
								type: "danger",
								insert: "top",
								container: "top-right",
								animationIn: ["animated", "fadeIn"],
								animationOut: ["animated", "fadeOut"],
								dismiss: {
									duration: 5000,
									onScreen: true,
								},
							});
							return reject();
						}
						console.log("newData=", newData);
						setTimeout(async () => {
							const token = localStorage.getItem("token");
							const config = {
								headers: {
									"x-auth-token": token,
									"content-type": "application/json",
								},
							};
							let inputs = {
								...params,
								username: newData.username,
								siteId: props.data.siteId,
								companyId: props.data.companyId,
								action: "map_user_to_site",
							};
							console.log(
								"UserInSite onRowUpdate action map_user_to_site inputs=",
								inputs
							);

							axios
								.post(IP.nodeServer + "api/manageUsers", inputs, config)
								.then((response) => {
									console.log(
										"UserInSite map_user_to_site response.data.map((x) => ({username: x.username,name: x.name,office_id: x.office_id,id: x._id,}))=",
										response.data
									);
									let value = [...data, response.data];
									console.log("UserInSite Value=", value);
									setData(value);
									tableRef.current && tableRef.current.onQueryChange();
									resolve();
									console.log(
										"UserInSite map_user_to_site response.data=",
										response.data
									);
								})
								.catch((error) => {
									console.log("UserInSite map_user_to_site error=", error);
									storeNotification.addNotification({
										title: "Updating User!",
										message: "failed to add !",
										type: "danger",
										insert: "top",
										container: "top-right",
										animationIn: ["animated", "fadeIn"],
										animationOut: ["animated", "fadeOut"],
										dismiss: {
											duration: 5000,
											onScreen: true,
										},
									});
									reject();
								});
						}, 1000);
					}),
				onRowDelete: (oldData) =>
					new Promise((resolve, reject) => {
						setTimeout(() => {
							const dataDelete = [...data];
							const index = oldData.tableData.id;
							dataDelete.splice(index, 1);
							setData([...dataDelete]);

							resolve();
						}, 1000);
					}),
			}}
			data={(query) =>
				new Promise((resolve, reject) => {
					const token = localStorage.getItem("token");
					const config = {
						headers: {
							"x-auth-token": token,
							"content-type": "application/json",
						},
					};
					let inputs = {
						...props.data,
						action: "get_site_user_list",
						limit: query.pageSize,
						page: query.page + 1,
					};
					console.log("UserInSite inputs=", inputs);

					axios
						.post(IP.nodeServer + "api/manageUsers", inputs, config)
						.then((response) => {
							console.log("UserInSite response.data=", response.data);
							resolve({
								data: response.data.docs,
								page: response.data.page - 1,
								totalCount: response.data.total,
							});
							setData(response.data.docs);

							console.log("UserInSite response.data=", response.data);
						})
						.catch((error) => {
							console.log("UserInSite error=", error);
						});
				})
			}
			actions={[
				{
					icon: "refresh",
					tooltip: "Refresh Data",
					isFreeAction: true,
					onClick: () => tableRef.current && tableRef.current.onQueryChange(),
				},
			]}
			options={{
				search: false,
				sorting: true,
			}}
		/>
	);
};

const DocumentSetting = (props) => {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	const tableRefAddOffice = React.createRef();
	const tableRulesRef = React.createRef();

	const { useState } = React;

	const [routes_rules, setRoutes_rules] = useState();

	console.log(
		"DocumentSetting state.loadRoutes.docType=",
		state.loadRoutes.docType
	);
	console.log(
		"DocumentSetting state.loadRoutes.routes_rules=",
		state.loadRoutes.routes_rules
	);

	const [data, setData] = useState([]);
	const [removeNewData, setRemoveNewData] = useState([]);
	const [selectedDocId, setSelectedDocId] = useState();
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const timer = React.useRef();

	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});

	const saveAddNewData = (data) => {
		console.log("saveAddNewData saved data=", data);
		console.log("saveAddNewData routes_rules =", routes_rules);
		new Promise((resolve, reject) => {
			const token = localStorage.getItem("token");
			const config = {
				headers: {
					"x-auth-token": token,
					"content-type": "application/json",
				},
			};
			let inputs = {
				action: "saveAddNewData",
				Doc_type_id: data.Doc_type_id,
				add_office_id:
					routes_rules.routes_rules[data.tableData.id].add_office_id,
			};
			console.log("UserInSite inputs=", inputs);

			axios
				.post(IP.nodeServer + "api/managerRoutesRules", inputs, config)
				.then((response) => {
					console.log("saveAddNewData axios response=", response);
				})
				.catch((error) => {
					console.log("saveAddNewData axios error=", error);
				});
		});
	};
	const saveNewRequiredDocsData = (data) => {
		console.log("saveNewRequiredDocs saved data=", data);
		console.log("saveNewRequiredDocs routes_rules =", routes_rules);

		new Promise((resolve, reject) => {
			if (!loading) {
				setSuccess(false);
				setLoading(true);
			}

			const token = localStorage.getItem("token");
			const config = {
				headers: {
					"x-auth-token": token,
					"content-type": "application/json",
				},
			};
			let inputs = {
				action: "saveNewRequiredDocs",
				Doc_type_id: data.Doc_type_id,
				requiredDocs: routes_rules.routes_rules[data.tableData.id].requiredDocs,
			};
			console.log("UserInSite inputs=", inputs);

			axios
				.post(IP.nodeServer + "api/managerRoutesRules", inputs, config)
				.then((response) => {
					console.log("saveNewRequiredDocs axios response=", response);
					setSuccess(true);
					setLoading(false);
				})
				.catch((error) => {
					setSuccess(false);
					setLoading(false);
					console.log("saveNewRequiredDocs axios error=", error);
				});
		});
	};
	const saveRemoveNewData = (data) => {
		console.log("saveRemoveNewData saved data=", data);
		console.log("saveRemoveNewData routes_rules =", routes_rules);

		new Promise((resolve, reject) => {
			if (!loading) {
				setSuccess(false);
				setLoading(true);
			}

			const token = localStorage.getItem("token");
			const config = {
				headers: {
					"x-auth-token": token,
					"content-type": "application/json",
				},
			};
			let inputs = {
				action: "saveRemoveNewData",
				Doc_type_id: data.Doc_type_id,
				add_office_id:
					routes_rules.routes_rules[data.tableData.id].remove_office_id,
			};
			console.log("UserInSite inputs=", inputs);

			axios
				.post(IP.nodeServer + "api/managerRoutesRules", inputs, config)
				.then((response) => {
					console.log("saveAddNewData axios response=", response);
					setSuccess(true);
					setLoading(false);
				})
				.catch((error) => {
					setSuccess(false);
					setLoading(false);
					console.log("saveAddNewData axios error=", error);
				});
		});
	};
	const setRoutes_rulesFx = (data) => {
		setRoutes_rules({ ...data, lastrefresh: new Date() });
		console.log("setRoutes_rulesFx data=", data);
	};

	React.useEffect(() => {
		console.log("DocumentSetting selectedDocId=", selectedDocId);
		if (selectedDocId) setData(selectedDocId.remove_office_id);
	}, [selectedDocId, setSelectedDocId]);

	React.useEffect(() => {
		console.log("useEffect routes_rules =", routes_rules);
		if (tableRulesRef.current) tableRulesRef.current.onQueryChange();
	}, [routes_rules, setRoutes_rules]);
	React.useEffect(() => {
		setRoutes_rules({ ...state.loadRoutes, lastrefresh: new Date() });
		return () => {
			clearTimeout(timer.current);
		};
	}, []);
	if (loading) {
		return (
			<div className={classes.rootProgress}>
				<LinearProgress />
			</div>
		);
	}

	return (
		<MaterialTable
			icons={tableIcons}
			tableRef={tableRulesRef}
			title="Document Rules"
			columns={[
				{ title: "Doc_Name", field: "Doc_Name" },
				{ title: "Doc_type_id", field: "Doc_type_id", editable: "never" },
				{
					title: "status",
					field: "status",

					editable: "never",
					render: (rowData) =>
						rowData ? (rowData.status === 1 ? "Active" : "Inactive") : "",
				},
				{ title: "status_date", field: "status_date", editable: "never" },
			]}
			data={(query) =>
				new Promise((resolve, reject) => {
					resolve({
						data: routes_rules.routes_rules,
					});

					console.log(
						"routes_rules.routes_rules[rowData.tableData.id].add_office_id=",
						routes_rules.routes_rules
					);
				})
			}
			editable={{
				onRowAdd: (newData) =>
					new Promise((resolve, reject) => {
						if (!newData.Doc_Name) {
							storeNotification.addNotification({
								title: "adding new Doctype!",
								message: "failed to add, fields 'Doc_Name' must not be empty !",
								type: "danger",
								insert: "top",
								container: "top-right",
								animationIn: ["animated", "fadeIn"],
								animationOut: ["animated", "fadeOut"],
								dismiss: {
									duration: 5000,
									onScreen: true,
								},
							});
							return reject();
						}
						setTimeout(() => {
							dispatch(
								saveDocType({
									data: { ...newData, action: "addDocType" },
									url: IP.nodeServer + "api/managerRoutesRules",
								})
							);

							resolve();
						}, 1000);
					}),
				onRowUpdate: (newData, oldData) =>
					new Promise((resolve, reject) => {
						if (!newData.Doc_Name) {
							storeNotification.addNotification({
								title: "adding new Doctype!",
								message:
									"failed to update, fields 'Doc_Name' must not be empty !",
								type: "danger",
								insert: "top",
								container: "top-right",
								animationIn: ["animated", "fadeIn"],
								animationOut: ["animated", "fadeOut"],
								dismiss: {
									duration: 5000,
									onScreen: true,
								},
							});
							return reject();
						}
						setTimeout(() => {
							dispatch(
								saveDocType({
									data: {
										...newData,
										action: "updateDocType",
									},
									url: IP.nodeServer + "api/managerRoutesRules",
								})
							);
							resolve();
						}, 1000);
					}),

				onRowDelete: (oldData) =>
					new Promise((resolve, reject) => {
						setTimeout(() => {
							dispatch(
								saveDocType({
									data: {
										_id: oldData._id,
										action: "deleteDocType",
									},
									url: IP.nodeServer + "api/managerRoutesRules",
								})
							);

							resolve();
						}, 1000);
					}),
			}}
			detailPanel={[
				{
					icon: () => <RemoveIcon />,
					tooltip: "Show office to remove",
					render: (rowData) => {
						console.log("routes_rules remove rowData", rowData);
						//setSelectedDocIdFx(rowData);
						return (
							<div
								style={{
									fontSize: 20,
									textAlign: "center",
									color: "white",
									backgroundColor: "#DEE0E3",
								}}
							>
								{rowData.Doc_Name}
								<div className={classes.root}>
									<Fab
										aria-label="save"
										color="primary"
										className={buttonClassname}
										onClick={() => saveRemoveNewData(rowData)}
									>
										<SaveIcon />
									</Fab>
								</div>

								<MaterialTable
									icons={tableIcons}
									title="Office to Remove"
									columns={[
										{
											title: "Approval level",
											field: "level",
											editable: "never",
											render: (rowData) =>
												rowData ? rowData.tableData.id : "",
										},
										{
											title: "office_id",
											field: "office_id",
											editComponent: (property) => (
												<Autocomplete
													onChange={(event, newValue) => {
														console.log(
															"remove new office change onChange=",
															newValue
														);

														if (newValue.office_id)
															property.onChange(newValue.office_id);
													}}
													inputValue={
														state.auth.user.allOffices.filter(
															(x) =>
																x.office_id === property.value &&
																x.companyId === props.selectedCompanyId
														).office_name
													}
													onInputChange={(event, newInputValue) => {
														console.log(
															"remove Office newInputValue=",
															newInputValue
														);
													}}
													id="combo-box-demo"
													options={state.auth.user.allOffices.filter(
														(x) =>
															!rowData.remove_office_id
																.map((z) => z.office_id)
																.includes(x.office_id) &&
															x.companyId === props.selectedCompanyId
													)}
													getOptionLabel={(option) => option.office_name}
													style={{ width: 300 }}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Office Name"
															variant="outlined"
														/>
													)}
												/>
											),
										},
										{
											title: "office_name",
											field: "office_name",
											editable: "never",
											render: (rowData) =>
												rowData
													? state.auth.user.allOffices.find(
														(x) =>
															x.office_id === rowData.office_id &&
															x.companyId === props.selectedCompanyId
													).office_name
													: "",
										},
									]}
									data={(query) =>
										new Promise((resolve, reject) => {
											resolve({
												data:
													routes_rules.routes_rules[rowData.tableData.id]
														.remove_office_id,
											});

											console.log(
												"routes_rules.routes_rules[rowData.tableData.id].add_office_id=",
												routes_rules.routes_rules[rowData.tableData.id]
													.remove_office_id
											);
										})
									}
									editable={{
										onRowAdd: (newData) =>
											new Promise((resolve, reject) => {
												if (!newData.office_id) {
													storeNotification.addNotification({
														title: "removing new Office!",
														message:
															"failed to add, fields 'office_id,' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before remove new Offices check rowData=",
														rowData
													);
													let tempdata = rowData.remove_office_id;
													tempdata.push(newData);

													let newAddOffice = {
														...rowData,
														remove_office_id: tempdata,
													};

													console.log(
														"before remove routes_rules",
														routes_rules
													);
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
										onRowUpdate: (newData, oldData) =>
											new Promise((resolve, reject) => {
												if (!newData.office_id) {
													storeNotification.addNotification({
														title: "adding new Office!",
														message:
															"failed to update, fields 'office_id' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before remove new Offices check rowData=",
														rowData
													);
													let newAddOffice = {
														...rowData,
														remove_office_id: [
															...rowData.remove_office_id.filter(
																(x, index) => index !== oldData.tableData.id
															),
															newData,
														],
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),

										onRowDelete: (oldData) =>
											new Promise((resolve, reject) => {
												setTimeout(() => {
													let deleteIndex = oldData.tableData.id;
													console.log(
														"before delete remove Offices check rowData=",
														rowData.remove_office_id,
														" oldData.tableData.id=",
														deleteIndex
													);
													let newAddOffice = {
														...rowData,
														remove_office_id: rowData.remove_office_id.filter(
															(x, index) => index !== deleteIndex
														),
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
									}}
								/>
							</div>
						);
					},
				},
				{
					icon: () => <AddIcon />,
					//openIcon: "favorite",
					tooltip: "Show Offices to add",

					render: (rowData) => {
						console.log("routes_rules rowData", rowData);
						//setSelectedDocIdFx(rowData);
						return (
							<div
								style={{
									fontSize: 20,
									textAlign: "center",
									color: "white",
									backgroundColor: "#DEE0E3",
								}}
							>
								{rowData.Doc_Name}
								<br />
								<Button onClick={() => saveAddNewData(rowData)}>save</Button>

								<MaterialTable
									icons={tableIcons}
									tableRef={tableRefAddOffice}
									title="Office to Add"
									columns={[
										{
											title: "Approval level",
											field: "level",
											editable: "never",
											render: (rowData) =>
												rowData ? rowData.tableData.id : "",
										},
										{
											title: "office_id",
											field: "office_id",
											editComponent: (property) => (
												<Autocomplete
													onChange={(event, newValue) => {
														console.log(
															"add new office change onChange=",
															newValue
														);

														if (newValue.office_id)
															property.onChange(newValue.office_id);
													}}
													inputValue={
														state.auth.user.allOffices.filter(
															(x) =>
																x.office_id === property.value &&
																x.companyId === props.selectedCompanyId
														).office_name
													}
													onInputChange={(event, newInputValue) => {
														console.log(
															"add Office newInputValue=",
															newInputValue
														);
													}}
													id="combo-box-demo"
													options={state.auth.user.allOffices.filter(
														(x) =>
															!rowData.add_office_id
																.map((z) => z.office_id)
																.includes(x.office_id) &&
															x.companyId === props.selectedCompanyId
													)}
													getOptionLabel={(option) => option.office_name}
													style={{ width: 300 }}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Office Name"
															variant="outlined"
														/>
													)}
												/>
											),
										},
										{
											title: "office_name",
											field: "office_name",
											editable: "onInsert",
											render: (rowData) =>
												rowData
													? state.auth.user.allOffices.find(
														(x) =>
															x.office_id === rowData.office_id &&
															x.companyId === props.selectedCompanyId
													).office_name
													: "",
										},
										{
											title: "order",
											field: "order",
											type: "numeric",
											editComponent: (props) => {
												return (
													<TextField
														id="selectOrder"
														label="Order"
														value={props.value}
														onChange={(event) => {
															console.log(
																"editComponent order event.target.value=",
																event.target.value
															);
															props.onChange(event.target.value);
														}}
														select
													>
														{[1, 2, 3, 4, 5, 6, 7, 10].map((x) => {
															if (
																!rowData.add_office_id
																	.map((x) => x.order)
																	.includes(x)
															)
																return <MenuItem value={x}>{x}</MenuItem>;
														})}
													</TextField>
												);
											},
										},
										{
											title: "mandatory",
											field: "mandatory",
											lookup: { true: "True", false: "False" },
										},
									]}
									data={(query) =>
										new Promise((resolve, reject) => {
											resolve({
												data:
													routes_rules.routes_rules[rowData.tableData.id]
														.add_office_id,
											});

											console.log(
												"routes_rules.routes_rules[rowData.tableData.id].add_office_id=",
												routes_rules.routes_rules[rowData.tableData.id]
													.add_office_id
											);
										})
									}
									editable={{
										onRowAdd: (newData) =>
											new Promise((resolve, reject) => {
												if (
													!newData.office_id ||
													!newData.order ||
													!newData.mandatory
												) {
													storeNotification.addNotification({
														title: "removing new Office!",
														message:
															"failed to add, fields 'office_id,order,mandatory' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before add new Offices check rowData=",
														rowData
													);
													console.log(
														"before adding routes_rules.routes_rules[rowData.tableData.id].add_office_id was =",
														routes_rules.routes_rules[rowData.tableData.id]
															.add_office_id
													);
													let tempdata = rowData.add_office_id;
													tempdata.push(newData);

													let newAddOffice = {
														...rowData,
														add_office_id: tempdata,
													};

													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
										onRowUpdate: (newData, oldData) =>
											new Promise((resolve, reject) => {
												if (
													!newData.office_id ||
													!newData.order ||
													!newData.mandatory
												) {
													storeNotification.addNotification({
														title: "removing new Office!",
														message:
															"failed to add, fields 'office_id,order,mandatory' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before add new Offices check rowData=",
														rowData
													);
													let newAddOffice = {
														...rowData,
														add_office_id: [
															...rowData.add_office_id.filter(
																(x, index) => index !== oldData.tableData.id
															),
															newData,
														],
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),

										onRowDelete: (oldData) =>
											new Promise((resolve, reject) => {
												setTimeout(() => {
													let deleteIndex = oldData.tableData.id;
													console.log(
														"before delete new Offices check rowData=",
														rowData.add_office_id,
														" oldData.tableData.id=",
														deleteIndex
													);
													let newAddOffice = {
														...rowData,
														add_office_id: rowData.add_office_id.filter(
															(x, index) => index !== deleteIndex
														),
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newAddOffice);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[index] = newAddOffice;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
									}}
								/>
							</div>
						);
					},
				},
				{
					icon: () => <DocIcon />,
					tooltip: "requiredDocs",
					render: (rowData) => {
						console.log("requiredDocs  rowData", rowData);
						//setSelectedDocIdFx(rowData);
						return (
							<div
								style={{
									fontSize: 20,
									textAlign: "center",
									color: "white",
									backgroundColor: "#DEE0E3",
								}}
							>
								{rowData.Doc_Name}
								<div className={classes.root}>
									<Fab
										aria-label="save"
										color="primary"
										className={buttonClassname}
										onClick={() => saveNewRequiredDocsData(rowData)}
									>
										<SaveIcon />
									</Fab>
								</div>

								<MaterialTable
									icons={tableIcons}
									title="requiredDocs"
									columns={[
										{
											title: "name",
											field: "name",
											validate: (rowData) =>
												rowData.name === ""
													? {
														isValid: false,
														helperText: "name cannot be empty",
													}
													: true,
										},
										{
											title: "DocType",
											field: "DocType",
											validate: (rowData) =>
												rowData.DocType === ""
													? {
														isValid: false,
														helperText: "DocType cannot be empty",
													}
													: true,
											render: (rowData) =>
												rowData.DocType ? rowData.DocType.join(",") : "",
											editComponent: (props) => {
												return (
													<TextField
														value={props.value}
														onChange={(event) => {
															props.onChange(event.target.value.split(","));
														}}
													/>
												);
											},
										},

										{
											title: "id",
											field: "id",
											validate: (rowData) =>
												rowData.id === ""
													? {
														isValid: false,
														helperText: "id cannot be empty",
													}
													: true,
											editComponent: (props) => {
												return (
													<TextField
														id="selectId"
														label="Id"
														value={props.value}
														onChange={(event) => {
															console.log(
																"editComponent order event.target.value=",
																event.target.value
															);
															props.onChange(event.target.value);
														}}
														select
													>
														{[1, 2, 3, 4, 5, 6, 7, 10].map((x) => {
															if (
																!rowData.requiredDocs
																	.map((x) => x.id)
																	.includes(x)
															)
																return <MenuItem value={x}>{x}</MenuItem>;
														})}
													</TextField>
												);
											},
										},
										{
											title: "mandatory",
											field: "mandatory",
											lookup: { Y: "YES", N: "NO" },
											validate: (rowData) =>
												rowData.mandatory === ""
													? {
														isValid: false,
														helperText: "mandatory cannot be empty",
													}
													: true,
										},
										{
											title: "allowDrafting",
											field: "allowDrafting",
											lookup: { true: "TRUE", false: "FALSE" },
										},
									]}
									data={(query) =>
										new Promise((resolve, reject) => {
											resolve({
												data:
													routes_rules.routes_rules[rowData.tableData.id]
														.requiredDocs,
											});

											console.log(
												"routes_rules.routes_rules[rowData.tableData.id].add_office_id=",
												routes_rules.routes_rules[rowData.tableData.id]
													.requiredDocs
											);
										})
									}
									editable={{
										onRowAdd: (newData) =>
											new Promise((resolve, reject) => {
												if (
													!newData.name ||
													!newData.DocType ||
													!newData.mandatory ||
													!newData.id ||
													!newData.allowDrafting
												) {
													storeNotification.addNotification({
														title: "addting new Office!",
														message:
															"failed to add, fields 'name,DocType,mandatory,id,allowDrafting' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before remove new Offices check rowData=",
														rowData
													);
													let tempdata = rowData.requiredDocs;
													tempdata.push({
														...newData,

														name: newData.name
															? newData.name.toUpperCase()
															: "",
													});

													let newRequiredDocs = {
														...rowData,
														requiredDocs: tempdata,
													};

													console.log(
														"before remove routes_rules",
														routes_rules
													);
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newAddOffice=", newRequiredDocs);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[
														index
													] = newRequiredDocs;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
										onRowUpdate: (newData, oldData) =>
											new Promise((resolve, reject) => {
												console.log("newData=", newData);
												if (
													!newData.name ||
													!newData.DocType ||
													!newData.mandatory ||
													!newData.id ||
													!newData.allowDrafting
												) {
													storeNotification.addNotification({
														title: "addting new Office!",
														message:
															"failed to edit, fields 'name,DocType,mandatory,id,allowDrafting' must not be empty !",
														type: "danger",
														insert: "top",
														container: "top-right",
														animationIn: ["animated", "fadeIn"],
														animationOut: ["animated", "fadeOut"],
														dismiss: {
															duration: 5000,
															onScreen: true,
														},
													});
													return reject();
												}
												setTimeout(() => {
													console.log(
														"before remove new Offices check rowData=",
														rowData
													);
													let newRequiredDocs = {
														...rowData,
														requiredDocs: [
															...rowData.requiredDocs.filter(
																(x, index) => index !== oldData.tableData.id
															),
															{
																...newData,

																name: newData.name
																	? newData.name.toUpperCase()
																	: "",
															},
														],
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newRequiredDocs=", newRequiredDocs);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[
														index
													] = newRequiredDocs;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),

										onRowDelete: (oldData) =>
											new Promise((resolve, reject) => {
												setTimeout(() => {
													let deleteIndex = oldData.tableData.id;
													console.log(
														"before delete requiredDocs  check rowData=",
														rowData.requiredDocs,
														" oldData.tableData.id=",
														deleteIndex
													);
													let newRequiredDocs = {
														...rowData,
														requiredDocs: rowData.requiredDocs.filter(
															(x, index) => index !== deleteIndex
														),
													};
													let new_routes_rules = routes_rules;
													const index = rowData.tableData.id;
													console.log("newRequiredDocs=", newRequiredDocs);
													console.log(
														"rowData.tableData.id=",
														rowData.tableData.id
													);
													console.log("new_routes_rules=", new_routes_rules);
													new_routes_rules.routes_rules[
														index
													] = newRequiredDocs;

													setRoutes_rulesFx(new_routes_rules);
													//tableRefAddOffice.current.onQueryChange();

													resolve({ data: new_routes_rules.routes_rules });
												}, 1000);
											}),
									}}
								/>
							</div>
						);
					},
				},
			]}
		/>
	);
};
function UserTreeTable(props) {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const [open, setOpen] = React.useState(false);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const [statusInfo, setStatusInfo] = React.useState({});
	const [status, setStatus] = React.useState({});
	const [selectedUserId, setSelectedUserId] = React.useState();
	const [alloffices, setAlloffices] = React.useState(state.officeData.isLoaded ? state.officeData.allOffice : [])
	const options = (selectedOfficeId) => state.auth.user.allOffices.filter(
		(x) => x.companyId === props.selectedCompanyId && x.office_id !== selectedOfficeId
	)
		;
	const filter = createFilterOptions();

	const handleUpdateOffice = (data) => {
		if (true) {
			let inputs = {
				url: IP.nodeServer + "api/officeRegister",
				data: {
					...data,
					rep_office: data.rep_office + "",

					action: "update_Office_save"
				}
			};

			console.log("OrganisationChart handleSaveNewOffice inputs=", inputs);
			store.dispatch(officeUpdate(inputs));
			store.dispatch({
				type: OFFICE_LOAD_INFO_INIT

			});

		}
	}

	const handleSaveNewStatus = () => {

		//console.log("handleSaveNewStatus status=",status)
		//console.log("handleSaveNewStatus selectedUserId=",selectedUserId)

		const token = localStorage.getItem("token");
		const config = {
			headers: {
				"x-auth-token": token,
				"content-type": "application/json",
			},
		};

		axios
			.post(
				IP.nodeServer + "api/saveUserStatus",
				{
					status: status.action === true ? {
						...status, reason: "On Duty",
						status: 1,
						statusId: 1
					} : status, username: state.auth.user.allUser.find(
						(y) =>
							y.companies.map((x) => x.companyId).includes(props.selectedCompanyId) &&
							y._id === selectedUserId
					), selectedUserId: selectedUserId
				},
				config
			)
			.then((response) => {
				console.log("saveUserStatus response=", response);
				if (response.data) {
					if (response.data.message) {
						dispatch(updateUser(response.data.message));
					}
				}
				if (response.data.success) {
					storeNotification.addNotification({
						title: "Status!",
						message: "New Status Saved",
						type: "success",
						insert: "top",
						container: "top-right",
						animationIn: ["animated", "fadeIn"],
						animationOut: ["animated", "fadeOut"],
						dismiss: {
							duration: 5000,
							onScreen: true,
						},
					});
					/*return dispatch({
						type: USER_STATUS_SAVED,
						payload: {
							status: response.data.message,
							image: response.data.image,
						},
					});
					*/
				} else {
					return;
				}
			})
			.catch((error) => {
				console.log("saveUserStatus error=", error);
			});
	}

	const handleClickOpen = (status) => {
		console.log("handleClickOpen status=", status)
		setStatusInfo(status.statusMoreInfo ? status.statusMoreInfo[0] : {})
		setSelectedUserId(status._id);
		setOpen(true);

	};

	const handleClose = () => {
		setOpen(false);
	};
	React.useEffect(() => {
		console.log("OrganisationChart UserTreeTable useEffect setStatus", status)

	}, [status, setStatus]);



	React.useEffect(() => {
		if (state.officeSave.isSaved) {
			/*console.log(
				"store.getState().officeSave.office.data=",
				state.officeSave.office.data
			);
*/
			let AllOfficesV = state.officeData.allOffice;


			let index = AllOfficesV.findIndex(x => x.office_id === state.officeSave.office.data.office_id)
			//console.log("changed index=",index)
			//console.log("state.officeSave.office.data=",state.officeSave.office.data)
			AllOfficesV[index] = state.officeSave.office.data;
			//AllOfficesV.map(x=>x.office_id===state.officeSave.office.data.office_id?state.officeSave.office.data:x)



			store.dispatch({
				type: OFFICE_LOAD_INFO,
				payload: AllOfficesV,
			});

		}
	}, [state.officeSave.isSaved])

	React.useEffect(() => {
		if (state.officeData.isLoaded) {
			setAlloffices(state.officeData.allOffice)
			//console.log("state.officeData.allOffice.find(x=>x.office_id===1)=",state.officeData.allOffice.find(x=>x.office_id===1))
		}
	}, [state.officeData.isLoaded]);

	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogTitle id="responsive-dialog-title">{"Edit user status?"}</DialogTitle>
				<DialogContent>
					<EditStatusForm statusMoreInfo={statusInfo} selectedUserId={selectedUserId} setStatus={setStatus} />
				</DialogContent>
				<DialogActions>
					<Button disabled={!status ? true : status.action === false ? (!status.fromDate || !status.toDate || !status.reason || !status.userActing) : false} autoFocus onClick={handleSaveNewStatus} color="primary">
						Save
					</Button>
					<Button autoFocus onClick={handleClose} color="primary">
						Cancel
					</Button>

				</DialogActions>
			</Dialog>
			<MaterialTable
				icons={tableIcons}
				title="Organisation Structure"
				data={alloffices.filter(
					(x) => x.companyId === props.selectedCompanyId
				)}
				columns={[
					{ title: "office_id", field: "office_id", editable: "never" },
					{ title: "office_name", field: "office_name" },
					{
						title: "assistant_offices", field: "assistant_offices",
						render: (rowData) =>



							(alloffices.filter(
								(x) => x.companyId === rowData.companyId && (rowData.assistant_offices ? rowData.assistant_offices.map(y => y.office_id).includes(x.office_id) : false)
							)).map(x => x.office_name).join("|")

						,
						editComponent: (props) => {
							//console.log("assistant_offices editComponent props=",props)
							return (
								<Autocomplete
									onChange={(event, newValue, reason) => {
										//console.log("Autocomplete newValue=", newValue, reason);
										//setPhones(newValue);
										//onChangeSite(event);
										props.onChange(newValue.map(x => ({ office_id: x.office_id })));
									}}
									filterOptions={(options, params) => {
										const filtered = filter(options, params);

										// Suggest the creation of a new value
										if (params.inputValue !== "") {

										}
										//console.log("value=", value);
										//filtered.push(value);

										return filtered;
									}}
									id="assitanceOffices"
									name="assitanceOffices"
									options={options(props.rowData.office_id)}
									getOptionLabel={(option) => {
										// Value selected with enter, right from the input
										if (typeof option === "string") {
											return option;
										}
										// Add "xxx" option created dynamically
										if (option.inputValue) {
											return option.inputValue;
										}
										// Regular option
										return option.office_name;
									}}
									multiple
									renderOption={(option) => {
										try {
											return option.office_name;
										} catch (e) { }
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											variant="standard"
											label="Assitance Office"
											placeholder="Offices"

											onChange={(value) => {
												//ValidateEmail()
												console.log("TextField value=", value.target);
											}}
										/>
									)}
								/>
							);
						}
					},
					{
						title: "is_senior", field: "is_senior",
						lookup: { true: "True", false: "False" }
					},
					{ title: "status", field: "status", lookup: { 1: "Active", 0: "Inactive" } },
				]}
				parentChildData={(row, rows) =>
					rows.find((a) => a.office_id === row.rep_office)
				}
				editable={state.userStatus.status.roles.filter((x) => x.role === "ADMIN").length >
					0 && {

					onRowUpdate: (newData, oldData) =>
						new Promise((resolve, reject) => {
							setTimeout(() => {
								//console.log("updating office newData=",newData)
								if (newData.office_name && newData.assistant_offices && newData.is_senior && newData.status) {

									handleUpdateOffice({
										companyId: newData.companyId,
										office_name: newData.office_name,
										office_id: newData.office_id,
										rep_office: newData.rep_office ? newData.rep_office : "",
										action: newData.action,
										assistant_offices: newData.assistant_offices,
										is_senior: newData.is_senior,
										status: parseInt(newData.status)
									})
								}
								else {
									storeNotification.addNotification({
										title: "update Office!",
										message:
											"failed to update, fields 'office_name,assistant_offices,is_senior and status,' must not be empty !",
										type: "danger",
										insert: "top",
										container: "top-right",
										animationIn: ["animated", "fadeIn"],
										animationOut: ["animated", "fadeOut"],
										dismiss: {
											duration: 5000,
											onScreen: true,
										},
									});

								}

								const index = oldData.tableData.id;


								resolve();
							}, 1000)
						})

					,

				}
				}
				detailPanel={[
					{
						icon: "account_circle",
						tooltip: "Show Surname",
						render: (rowData) => {
							return (
								<>
									<div
										style={{
											fontSize: 20,
											textAlign: "center",
											color: "white",
											backgroundColor: "#E53935",
										}}
									>
										{rowData.office_name}
									</div>
									<MaterialTable
										title="User(s)"
										columns={[
											{ title: "Name", field: "name", editable: "never" },

											{
												title: "username",
												field: "username",
											},

											{
												title: "Role",
												field: "roles",
												render: (rowData) => {
													try {
														return rowData.roles.length > 0
															? rowData.roles.map((x) => x.role).join(";")
															: "";
													} catch (e) { }
												},
											},
										]}
										data={state.auth.user.allUser.filter(
											(x) =>
												x.companies
													.map((x) => x.companyId)
													.includes(props.selectedCompanyId) &&
												x.status === 1 &&
												x.office_id === rowData.office_id
										)}
										editable={false && {
											onRowAdd: newData =>
												new Promise((resolve, reject) => {
													setTimeout(() => {


														resolve();
													}, 1000)
												}),
											onRowUpdate: (newData, oldData) =>
												new Promise((resolve, reject) => {
													setTimeout(() => {

														const index = oldData.tableData.id;


														resolve();
													}, 1000)
												}),
											onRowDelete: oldData =>
												new Promise((resolve, reject) => {
													setTimeout(() => {

														const index = oldData.tableData.id;


														resolve()
													}, 1000)
												}),
										}}

									/>
								</>
							);
						},
					},
				]}
			/>
		</div>
	);
}

export default OrganisationChart;
